export * from '@sentry/browser';
export { init } from './sdk';
export { vueRouterInstrumentation } from './vuerouter';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/buzius/projects/easyflow-docker/workspace/easyflow/node_modules/@sentry/vue/esm/index.js
// module id = 236
// module chunks = 0